var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2491_16402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 40C80 62.0917 62.0917 80 40 80C17.9083 80 0 62.0917 0 40C0 17.9083 17.9083 0 40 0C62.0917 0 80 17.9083 80 40Z",
    fill: "url(#paint0_linear_2491_16402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9186 46.8481C27.9186 48.0914 26.9109 49.0991 25.6676 49.0991C24.4243 49.0991 23.416 48.0914 23.416 46.8481C23.416 45.6049 24.4243 44.5972 25.6676 44.5972C26.9109 44.5972 27.9186 45.6049 27.9186 46.8481Z",
    fill: "url(#paint1_linear_2491_16402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1089 44.5972C32.8656 44.5972 31.8579 45.6049 31.8579 46.8481C31.8579 48.0914 32.8656 49.0991 34.1089 49.0991C35.3522 49.0991 36.3599 48.0914 36.3599 46.8481C36.3599 45.6049 35.3522 44.5972 34.1089 44.5972Z",
    fill: "url(#paint2_linear_2491_16402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8014 46.8481C44.8014 48.0914 43.7937 49.0991 42.5504 49.0991C41.3071 49.0991 40.2988 48.0914 40.2988 46.8481C40.2988 45.6049 41.3071 44.5972 42.5504 44.5972C43.7937 44.5972 44.8014 45.6049 44.8014 46.8481Z",
    fill: "url(#paint3_linear_2491_16402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3556 46.8481C53.3556 48.0914 52.3479 49.0991 51.1046 49.0991C49.8613 49.0991 48.853 48.0914 48.853 46.8481C48.853 45.6049 49.8613 44.5972 51.1046 44.5972C52.3479 44.5972 53.3556 45.6049 53.3556 46.8481Z",
    fill: "url(#paint4_linear_2491_16402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8492 60.9375H22.066C19.6344 60.9375 17.6562 58.9594 17.6562 56.5277V38.0695C17.6562 35.6378 19.6344 33.6597 22.066 33.6597H54.4812C56.9122 33.6597 58.8904 35.6378 58.8904 38.0695V42.5714C58.8904 43.8654 59.9396 44.9152 61.2341 44.9152C62.5287 44.9152 63.5779 43.8654 63.5779 42.5714V38.0695C63.5779 33.053 59.4971 28.9722 54.4812 28.9722H51.8683V21.1261C51.8683 13.7848 45.7678 7.8125 38.269 7.8125C30.7709 7.8125 24.6704 13.7854 24.6704 21.1261V28.9722H22.066C17.0496 28.9722 12.9688 33.053 12.9688 38.0695V56.5277C12.9688 61.5442 17.0496 65.625 22.066 65.625H39.8492C41.1432 65.625 42.193 64.5752 42.193 63.2812C42.193 61.9867 41.1438 60.9375 39.8492 60.9375ZM29.3579 21.1261C29.3579 16.3696 33.3551 12.5 38.269 12.5C43.183 12.5 47.1808 16.3696 47.1808 21.1261V28.9722H29.3579V21.1261Z",
    fill: "url(#paint5_linear_2491_16402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8016 44.4922C68.7493 43.739 67.2857 43.9813 66.5319 45.0336L55.4388 60.5292C55.158 60.8521 54.8077 60.9223 54.6191 60.9345C54.4256 60.9473 54.0539 60.9229 53.7255 60.6159L46.5551 53.6188C45.6286 52.7149 44.1448 52.7326 43.2409 53.6591C42.3364 54.5856 42.3547 56.0693 43.2812 56.9733L50.4644 63.9832C50.4717 63.9899 50.4784 63.9966 50.4858 64.0033C51.5801 65.0452 53.0407 65.6244 54.5428 65.6244C54.6722 65.6244 54.8016 65.6201 54.931 65.6116C56.5679 65.5023 58.0962 64.7064 59.1235 63.4277C59.1509 63.3936 59.1772 63.3594 59.2022 63.324L70.3429 47.7625C71.0967 46.7102 70.8544 45.246 69.8016 44.4922Z",
    fill: "url(#paint6_linear_2491_16402)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2491_16402",
    x1: 40,
    y1: 80,
    x2: 40,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2491_16402",
    x1: 24.8203,
    y1: 49.8681,
    x2: 25.8715,
    y2: 43.7941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638903,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2491_16402",
    x1: 33.262,
    y1: 49.8681,
    x2: 34.3133,
    y2: 43.7941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638903,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2491_16402",
    x1: 41.7031,
    y1: 49.8681,
    x2: 42.7543,
    y2: 43.7941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638903,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2491_16402",
    x1: 50.2573,
    y1: 49.8681,
    x2: 51.3085,
    y2: 43.7941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638903,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2491_16402",
    x1: 28.7533,
    y1: 75.5,
    x2: 44.0393,
    y2: -1.81431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638903,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2491_16402",
    x1: 51.3718,
    y1: 69.3088,
    x2: 55.2706,
    y2: 39.8508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638903,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2491_16402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.5ac024ece233af0bc1dc82645ecd1aa2.svg";
export { ForwardRef as ReactComponent };